var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid),expression:"valid"}],attrs:{"id":"map"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}]},[_vm._v(_vm._s(_vm.$t('sensors.locationGPSInfo')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }